export default __webpack_public_path__ + "static/icon-webex-468819840b5b745c1ec67f1ebcd45e3a.png";